<template>
  <v-app id="app" :style="{background: appColor_Background}">
    <app-toolbar />
    <v-main>
      <router-view />
    </v-main>
    <app-footer />
  </v-app>
</template>

<script>
import AppFooter from '@/components/AppFooter'
import AppToolbar from '@/components/AppToolbar'
import { AppColor } from '@/config.js'

export default {
  name: 'App',
  components: {
    AppToolbar,
    AppFooter
  },
  data () {
    return {
      appColor_Background: AppColor.Background
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
